import React, { Component } from 'react';
import { routes } from '../../../../../utility/constants/constants';
import * as actions from '../../../../../redux/actions/index';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { animateScroll as scroll} from 'react-scroll'
import storage from '../../../../../utility/storage';
import JobCards from '../../../../component/FormAuditModule/BuildingProfileComponent/JobCards/jobCards';

var moment = require('moment');
const cloneDeep = require('clone-deep');

class JobCardsContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
        }
    }

    componentDidMount() {
        scroll.scrollToTop();
    }

    componentDidUpdate(prevProps, prevState) {
        const user = storage.get('user');
        if(user) {
            if(prevProps.user.selected_mode !== user.selected_mode) {
                this.props.scheduledTaskListPageClicked(0)
            }
        }
    }

    // resetClicked = () => {
    //     const page = 1
    //     const limit = this.props.scheduledTaskList_no_of_rows
    //     this.props.reset('searchScheduledTask');
    //     this.props.scheduledTaskListPageClicked(0)
    //     this.props.getScheduledTask({page,limit})

    // }

    // searchInventoryItemsListClicked = (value) => {
    //     const values = cloneDeep(value)
    //     let accountId =  null;
    //     let taskName = null;
    //     let companyName = null;
    //     let accountName = null;
    //     let from = null;
    //     let to = null;
    
    //     const page = 1
    //     const limit = this.props.scheduledTaskList_no_of_rows
    //     if(values.id) {
    //         values.id = values.id.trim()
    //         accountId = values.id
    //     }
    //   if(values.name) {
    //       values.name = values.name.trim()
    //       taskName = values.name
    //   }
    //   if(values.company) {
    //     values.company = values.company.trim()
    //     companyName = values.company
    //   }
    //   if(values.job) {
    //     values.job = values.job.trim()
    //     accountName =  values.job 
    //     }  
    //   if(values.fromDate) {
    //     values.fromDate = convertDateToDifferentTZ(values.fromDate, 'from');
    //     from = values.fromDate.split('T')[0];
    //   }  
    //   if(values.toDate) {
    //     values.toDate = convertDateToDifferentTZ(values.toDate, 'to');
    //     to = values.toDate.split('T')[0];
    //   }  
     
    //     this.props.getScheduledTask({page,limit,accountId,taskName,companyName,accountName,from,to}, values);
    // }
    newTicketClicked = () => {
        this.props.history.push(routes.NEW_JOB_CORE_MAP_CARD);
    }
         
    render() {
        return (
            <JobCards
            {...this.props}
            isLoading={this.props.isLoading}
            jobcard_list={this.props.jobcard_list ? this.props.jobcard_list : []}
            newTicketClicked={this.newTicketClicked}
                
            />
        )
    }
}




const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
        isLoading: state.LogBookReducer.isLoading,
        jobcard_list: state.BuildingProfileReducer.jobcard_list,
        isjobCards:state.BuildingProfileReducer.isjobCards
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reset: (searchInventoryItemsList) => dispatch(reset(searchInventoryItemsList)),  // requires form name
        getAllJobCards: (params) => dispatch(actions.getAllJobCards(params)),
        jobCardPageClicked: (params) => dispatch(actions.jobCardPageClicked(params)),
        scheduledTaskListPageClicked: (params) => dispatch(actions.scheduledTaskListPageClicked(params)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(JobCardsContainer);